<template>
<div class="clearfix">
    <div class="wrapper">
        <div class="col-xs-120 no-padding">
            <ul id="brands-page-list">
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>AC</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Acura</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Adler</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                            <img src="/static/uploads/2018/03/23/16/05/1cddf29fee5e23676fab0c2fa2a57cc7.png">
                        </div>
                        <div>Alfa Romeo</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Alpina</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Alpine</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>AMC</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Ariel</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Aro</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Asia</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Aston Martin</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Audi</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Austin</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Austin Healey</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Avia</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Barkas</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>BAW</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Bentley</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>BMW</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Borgward</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Brilliance</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Bristol</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Bugatti</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Buick</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>BYD</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Cadillac</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Callaway</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Carbodies</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Caterham</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Chana</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Changan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ChangFeng</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Changhe</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Chery</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Chevrolet</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Chrysler</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Citroen</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Cizeta</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Coggiola</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Dacia</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Dadi</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Daewoo</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Daihatsu</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Daimler</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Dallas</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Datsun</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>De Tomaso</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>DeLorean</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Derways</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>DFSK</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Dodge</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>DongFeng</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Doninvest</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>DS</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Eagle</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Efini</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Excalibur</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>FAW</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Ferrari</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Fiat</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Fisker</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                            <img src="/static/uploads/2018/03/23/15/51/7b46d859a4c539d040958eff8e1b8471.png">
                        </div>
                        <div>Ford</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Foton</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>FSC</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>FSO</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Fuqi</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Gac Gonow</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Geely</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Genesis</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Geo</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>GMC</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Great Wall</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Groz</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Hafei</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Haima</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Haval</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Hawtai</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Hindustan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>HINO</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Holden</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Honda</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>HuangHai</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Hummer</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Hurtan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Hyundai</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Infiniti</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Innocenti</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>International</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Invicta</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Iran Khodro</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Isdera</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Isuzu</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>IVECO</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>JAC</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Jaguar</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>JBC-Rus</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Jeep</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Jiangnan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Jinbei</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>JMC</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Kia</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Koenigsegg</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Lamborghini</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Lancia</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Land Rover</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Landwind</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>LDV</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Lexus</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Lifan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Lincoln</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Lotus</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>LTI</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Luxgen</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mahindra</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>MAN</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Marcos</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Marlin</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Marussia</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Maruti</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Maserati</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Maxus</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Maybach</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mazda</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>McLaren</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mega</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mercedes-Benz</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mercury</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Metrocab</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>MG</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Minelli</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mini</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mitsubishi</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Mitsuoka</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Monte Carlo</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Morgan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>NAVECO</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Nissan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Noble</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Nysa</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Oldsmobile</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Opel</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Osca</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Packard</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Pagani</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Panoz</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Paykan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Perodua</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Peugeot</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Plymouth</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Pontiac</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Porsche</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Premier</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Proton</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Puma</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Qoros</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Qvale</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>RAM</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Ravon</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Reliant</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Renaissance Cars</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Renault</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Robur</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Rolls-Royce</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Ronart</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Rover</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Saab</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Saleen</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Samsung</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Santana</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Saturn</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Scion</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>SEAT</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Shifeng</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ShuangHuan</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Skoda</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>SMA</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Smart</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Sokon</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Soueast</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Spectre</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Spyker</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>SsangYong</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Subaru</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Suzuki</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Talbot</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Tata</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Tatra</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Tesla</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Tianma</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Tianye</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Tofas</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Toyota</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Trabant</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>TVR</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Vauxhall</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Vector</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Venturi</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Volkswagen</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Volvo</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Vortex</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Wartburg</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Westfield</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Wiesmann</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Wuling</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Xin Kai</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Yuejin</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Zastava</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Zibar</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Zotye</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ZX</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ВАЗ (Lada)</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ВИС</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ГАЗ</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Гуран</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ЗАЗ</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ЗИЛ</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ИЖ</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Комбат</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ЛуАЗ</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Москвич</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>Прочие авто</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>СМЗ</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>ТагАЗ</div>
                    </router-link>
                </li>
                <li>
                    <router-link to="/car-marks-list/#">
                        <div class="img">
                        </div>
                        <div>УАЗ</div>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'AllMarks'
}
</script>

<style scoped>
    #brands-page-list {
        margin: 0;
        padding: 20px 0;
    }
    #brands-page-list li{
        display: inline-block;
        width: calc(100% / 8 - 20px);
        list-style: none;
        border-radius: 5px;
        margin: 0 5px 10px 5px;
        box-shadow: 0 0 3px 1px #9c9c9c;
    }
    #brands-page-list li > a{
        color: #3a3a3a;
        padding: 10px;
        text-decoration: none;
        display: block;
        font-weight: 600;
        text-align: center;
    }
    #brands-page-list li > a > div{
    }
    #brands-page-list li > a > div.img{
        width: 42px;
        height: 42px;
        vertical-align: middle;
        margin: 0 auto;
        line-height: 36px;
    }
    #brands-page-list li > a img{
        width: 100%;
        height: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/AllMarks.vue